/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Shop_Tier_FromInputs */

const vi_shop_tier_from = /** @type {(inputs: Shop_Tier_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.amount}`)
};

/**

* @param {Shop_Tier_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_from = /** @type {((inputs: Shop_Tier_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_FromInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_from(inputs)
});